import React from 'react';

export const CheckboxSquarePrimaryUncheckedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="20" height="20" rx="5" fill="#774EFF" />
    </svg>
  );
};
